import { THttpService } from '@/services/HttpService';

import { TCard } from '../Recommendation/types/template2';

export const getDetails = async (
  api: THttpService,
  path: string,
): Promise<TCard> => {
  const pathWhithoutPrefix = path.replace('/v2', '');
  const { data } = await api.get(pathWhithoutPrefix);
  return data;
};
